import styles from "./SignPost.module.scss";

type Props = {
  title: string;
};

export const SignPost = ({ title }: Props) => {
  return (
    <div
      data-testid="product:bundleSignpost"
      className={styles.bundleSignpost}
      data-component="BundleSignPost"
    >
      {title}
    </div>
  );
};
